<template>
  <div class="edit-customer">
    <div class="page-header">
      <div class="page-header__left">
        <el-button
          class="btn-back"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.push({path: '/app/settings'})">
          {{ $t('settings.overview') }}
        </el-button>
        <span class="page-header__sep">/</span>
        <h2 class="page-header__title">{{ $t('settings.editCustomer') }}</h2>
      </div>

      <div class="page-header__actions">
        <base-button
          type="primary"
          icon="el-icon-user"
          @click="$router.push({path: `/app/settings/${$route.params.id}/accounts`})">
          {{ $t('settings.showCustomerAccounts') }}
        </base-button>
        <base-button
          type="primary"
          icon="el-icon-plus"
          @click="$router.push({path: `/app/settings/${$route.params.id}/account/create`})">
          {{ $t('settings.createLocalAccount') }}
        </base-button>
        <base-button
          type="danger"
          icon="el-icon-delete"
          @click="deleteCustomer">
          {{ $t('settings.deleteCustomer') }}
        </base-button>
      </div>
    </div>

    <customer-form-component
      :customer="customer"
      mode="edit"
      @submit="onSubmit">
    </customer-form-component>

    <base-delete-dialog
      :visible.sync="showDeleteDialog"
      :title="$t('settings.deleteCustomer')"
      :text="$t('settings.deleteCustomerInfoText')"
      :confirm-label="$t('settings.deleteCustomer')"
      width="400px"
      :loading="deleteLoading"
      @confirm="confirmDelete"/>
  </div>
</template>

<script>
import BaseButton from '@/components/common/BaseButton';
import {createNamespacedHelpers} from 'vuex';
import {customerService} from "@/services/CustomerService.class";
import CustomerFormComponent from './CustomerForm';
import BaseDeleteDialog from '@/components/common/BaseDeleteDialog';

const mspStateMappers = createNamespacedHelpers('msp');

export default {
  name: "EditCustomer",
  components: {CustomerFormComponent, BaseDeleteDialog, BaseButton},
  data() {
    return {
      customer: null,
      customerForm: null,
      showDeleteDialog: false,
      deleteLoading: false,
    }
  },
  mounted() {
    this.getCustomer();
  },
  beforeRouteUpdate(to, from, next) {
    this.getCustomer();
    next();
  },
  methods: {
    ...mspStateMappers.mapActions(['getCustomerByIdAction']),
    getCustomer() {
      this.getCustomerByIdAction(this.$route.params.id).then((customer) => {
        this.customer = customer;
      });
    },
    deleteCustomer() {
      this.showDeleteDialog = true;
    },
    confirmDelete() {
      this.deleteLoading = true;
      customerService.delete(this.$route.params.id).then(() => {
        this.$message({type: 'success', message: this.$t('settings.customerDeleted')});
        setTimeout(() => this.$router.replace({path: '/app/settings'}), 200);
      }).catch(() => {
        this.$message({type: 'error', message: this.$t('settings.genericHttpError')});
      }).finally(() => {
        this.deleteLoading = false;
        this.showDeleteDialog = false;
      });
    },
    onSubmit(customer) {
      customerService.patch(customer).then(() => {
        this.$message({type: 'success', message: this.$t('settings.patchSuccess')});
      }).catch(() => {
        this.$message({type: 'error', message: this.$t('settings.genericHttpError')});
      });
    },
  }
}
</script>

<style scoped lang="scss">
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;

  &__left {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__sep {
    color: #ddd;
    font-size: 16px;
    user-select: none;
  }

  &__title {
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    color: var(--text-primary);
  }

  &__actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
}

.btn-back {
  color: var(--text-secondary);
  font-size: 13px;
  padding: 0;

  &:hover {
    color: var(--primary);
  }
}

</style>
